import React, { useState } from "react";
import Container from "../components/Layout/Container";
import { QueryClient, QueryClientProvider } from "react-query";
import AlsoIncomeModuleScreen from "./AlsoIncomeModuleScreen";
import AlsoIncomeReviewModuleScreen from "./AlsoIncomeReviewModuleScreen";
import AlsoIncomePendingModuleScreen from "./AlsoIncomePendingModuleScreen";

export const queryProductsClient = new QueryClient();

export default function AlsoIncomesIndex({ match, history }) {
  const [tabId, setTabId] = useState("all_documents");
  console.log(tabId, "tabId");
  const renderTabContent = () => {
    switch (tabId) {
      case "all_documents":
        return (
          <AlsoIncomeModuleScreen
            match={match}
            history={history}
            tabId={tabId}
            setTabId={setTabId}
          />
        );
      case "require_review":
        return (
          <AlsoIncomeReviewModuleScreen
            match={match}
            history={history}
            tabId={tabId}
            setTabId={setTabId}
          />
        );
      case "pending":
        return (
          <AlsoIncomePendingModuleScreen
            match={match}
            history={history}
            tabId={tabId}
            setTabId={setTabId}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <QueryClientProvider client={queryProductsClient}>
        {renderTabContent()}
      </QueryClientProvider>
    </>
  );
}
